import {Serializer, Serializers} from "../../interfaces/serializer";
import {User} from "../../interfaces/user";
import {Site} from "../../interfaces/site";
import {UserComponentObject} from '../../classes/user-component-object';

export const USERS_STATE_NAME = 'users';

export interface UsersState {
  users: Serializers<User>;
  componentObjects: Array<UserComponentObject>,
  canCreate: boolean;
  loading: boolean;
  loaded: boolean;
}

export interface UserRole {
  dataset: number,
  role: string
}

export interface UserRoles {
  roles: Array<UserRole>,
  sites: Serializers<Site>
}

export interface CreateUserSuccessAction {
  user: Serializer<User>,
  userRoles: UserRoles
}


